export default "__VITE_ASSET__CMsV5cjP__"